// prolificService.ts

export const getProlificParticipantId = (search: string): string | null => {
  const params = new URLSearchParams(search);
  console.log(params.get('PROLIFIC_PID'));
  return params.get('PROLIFIC_PID');
};
